import * as API_ENDPOINTS from "./apiEndpoints";
import * as ASSET from "./asset";
import * as AUTH from "./auth";
import * as BILLING from "./billing";
import * as COMMON from "./common";
import * as DASHBOARD from "./dashboard";
import * as DOCUMENTS from "./document";
import * as DRAFT from "./draft";
import * as ERROR_MSG from "./errorMsg";
import * as EVENTS from "./events";
import * as FALLBACK_DATA from "./fallbackData";
import * as FEATURES from "./features";
import * as GRID from "./agGrid";
import * as IMAGE_URLS from "./images";
import LOADING_MSG from "./loadingMsg";
import * as NAVBAR from "./navbar";
import * as OPPORTUNITIES from "./opportunities";
import * as PATHS from "./paths";
import * as PERMISSIONS from "./permissions";
import * as PIPELINE from "./pipeline";
import * as PRICEBOOK from "./pricebook";
import * as QUOTES from "./quotes";
import * as SETTINGS from "./settings";
import * as TEMPLATE from "./template";
import * as TOOLPANE from "./toolpane";
import * as WORKFLOW from "./workflow";
import * as ACTIVITIES from "./activities";
import * as GOOGLE_SHEET_VIEW_CONTROL from "./googleSheetConst";
import * as COVERPAGETEMPLATES from "./coverpageTemplates";
import * as OAUTH_CONSENT from "./oauthConsent";

export {
  API_ENDPOINTS,
  ASSET,
  AUTH,
  BILLING,
  COMMON,
  DASHBOARD,
  DOCUMENTS,
  DRAFT,
  ERROR_MSG,
  EVENTS,
  FALLBACK_DATA,
  FEATURES,
  GRID,
  IMAGE_URLS,
  LOADING_MSG,
  NAVBAR,
  OPPORTUNITIES,
  PATHS,
  PERMISSIONS,
  PIPELINE,
  PRICEBOOK,
  QUOTES,
  SETTINGS,
  TEMPLATE,
  TOOLPANE,
  WORKFLOW,
  ACTIVITIES,
  GOOGLE_SHEET_VIEW_CONTROL,
  COVERPAGETEMPLATES,
  OAUTH_CONSENT,
};



// WEBPACK FOOTER //
// ./src/constants/index.js